import { useQuery } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api';
import { GC_MANAGED_TEMPLATE_METADATAS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useGCManagedTemplateMetadatas(params: {
  is_cloneable?: boolean;
  include_deprecated?: boolean;
}) {
  const questionnaireApi = new QuestionnairesApi();
  const { userBankId } = useUser();

  const { data: gcManagedTemplateMetadatas, isLoading: isLoadingGCManagedTemplateMetadatas } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [GC_MANAGED_TEMPLATE_METADATAS_KEY, userBankId, params],
    queryFn: () => questionnaireApi.getGCManagedTemplateMetadatas(userBankId, params)
  });

  return { gcManagedTemplateMetadatas, isLoadingGCManagedTemplateMetadatas };
}
